export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-smartsoft.vue?vue&type=template&id=81e97632&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-smartsoft.vue?vue&type=template&id=81e97632&scoped=true
// module id = PzeE
// module chunks = 0